<template>
  <q-section :bg-i="uiMeta?.images?.lotteryBg[active]" :key="uiMeta?.images?.lotteryBg[active]" pc="x" pt="0">
    <!-- 小球的容器 -->
    <q-section wh="160" pc="x" pt="72" class="balls-container">
      <q-section
        v-for="(ball, index) in uiMeta?.layout?.ballsConfig"
        v-bind="ball"
        :key="ball"
        :class="isLotterying ? `ball${(index as number) + 1}` : ''"></q-section>
      <q-section :bg-i="uiMeta?.images?.lotteryGlassBg" pc="pc"></q-section>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
import { ref } from 'vue'
const isLotterying = ref(false)
// import { defaultConfig as uiMeta } from './use-lottery'

const props = defineProps({
  uiMeta: {
    type: Object,
    default: () => {},
  },
  active: {
    type: Number,
    default: 0,
  },
})

const startLottery = (time: number) => {
  return new Promise(resolve => {
    isLotterying.value = true
    setTimeout(() => {
      isLotterying.value = false
      resolve(true)
    }, time)
  })
}

defineExpose({
  startLottery,
})
</script>

<style scoped lang="scss">
.ball1 {
  animation: move1 0.75s 6 linear;
}
.ball2 {
  animation: move2 0.75s 6 linear;
}
.ball3 {
  animation: move3 0.75s 6 linear;
}
.ball4 {
  animation: move4 0.75s 6 linear;
}
.ball5 {
  animation: move5 0.75s 6 linear;
}
.ball6 {
  animation: move6 0.75s 6 linear;
}
.ball7 {
  animation: move7 0.75s 6 linear;
}
.ball8 {
  animation: move8 0.75s 6 linear;
}
/* 蛋滚动 */
@keyframes move1 {
  0% {
    transform: rotate(-30deg);
    left: 12.7%;
    top: 57.9%;
  }

  26% {
    transform: rotate(60deg);
    left: 41.2%;
    top: 8.9%;
  }

  44% {
    transform: rotate(110deg);
    left: 52.2%;
    top: 21.8%;
  }

  64% {
    transform: rotate(56deg);
    left: 72%;
    top: 38%;
  }

  100% {
    transform: rotate(-30deg);
    left: 12.7%;
    top: 57.9%;
  }
}

@keyframes move2 {
  0% {
    transform: rotate(85deg);
    left: 31.2%;
    top: 57.9%;
  }

  23% {
    transform: rotate(210deg);
    left: 70%;
    top: 36%;
  }

  45% {
    transform: rotate(120deg);
    left: 45%;
    top: 8%;
  }

  72% {
    transform: rotate(30deg);
    left: 8%;
    top: 34%;
  }

  100% {
    transform: rotate(85deg);
    left: 31.2%;
    top: 57.9%;
  }
}

@keyframes move3 {
  0% {
    transform: rotate(-10deg);
    left: 50%;
    top: 57.9%;
  }

  38% {
    transform: rotate(-30deg);
    left: 38%;
    top: 11.4%;
  }

  65% {
    transform: rotate(-50deg);
    left: 7%;
    top: 38.7%;
  }

  100% {
    transform: rotate(-10deg);
    left: 50%;
    top: 57.9%;
  }
}

@keyframes move4 {
  0% {
    transform: rotate(20deg);
    left: 65%;
    top: 59.9%;
  }

  35% {
    transform: rotate(-30deg);
    left: 53.4%;
    top: 11.3%;
  }

  64% {
    transform: rotate(-53deg);
    left: 24.3%;
    top: 56%;
  }

  100% {
    transform: rotate(20deg);
    left: 65%;
    top: 59.9%;
  }
}

@keyframes move5 {
  0% {
    transform: rotate(-65deg);
    left: 61.4%;
    top: 38%;
  }

  29% {
    transform: rotate(-180deg);
    left: 40%;
    top: 11.5%;
  }

  53% {
    transform: rotate(-222deg);
    left: 9%;
    top: 41.3%;
  }

  76% {
    transform: rotate(-160deg);
    left: 21.8%;
    top: 57.9%;
  }

  100% {
    transform: rotate(-65deg);
    left: 61.4%;
    top: 38%;
  }
}

@keyframes move6 {
  0% {
    transform: rotate(16deg);
    left: 44.2%;
    top: 42%;
  }

  28% {
    transform: rotate(-60deg);
    left: 18%;
    top: 57%;
  }

  40% {
    transform: rotate(-45deg);
    left: 8%;
    top: 41.3%;
  }

  80% {
    transform: rotate(70deg);
    left: 52.7%;
    top: 9.9%;
  }

  100% {
    transform: rotate(16deg);
    left: 44.2%;
    top: 42%;
  }
}

@keyframes move7 {
  0% {
    transform: rotate(-13deg);
    left: 27.5%;
    top: 39.9%;
  }

  17% {
    transform: rotate(50deg);
    left: 37.5%;
    top: 57.9%;
  }

  44% {
    transform: rotate(75deg);
    left: 75%;
    top: 41.3%;
  }

  67% {
    transform: rotate(42deg);
    left: 50.18%;
    top: 8%;
  }

  100% {
    transform: rotate(-13deg);
    left: 27.5%;
    top: 39.9%;
  }
}

@keyframes move8 {
  0% {
    transform: rotate(46deg);
    left: 14.4%;
    top: 33.9%;
  }

  20% {
    transform: rotate(97deg);
    left: 45.6%;
    top: 7.8%;
  }

  45% {
    transform: rotate(143deg);
    left: 76.8%;
    top: 41.6%;
  }

  65% {
    transform: rotate(85deg);
    left: 64.6%;
    top: 57%;
  }

  100% {
    transform: rotate(46deg);
    left: 14.4%;
    top: 33.9%;
  }
}
</style>
